import { render, staticRenderFns } from "./ClientSelector.vue?vue&type=template&id=65d31dcb"
import script from "./ClientSelector.vue?vue&type=script&lang=js"
export * from "./ClientSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports